/**
 *
 *浏览器页面叉掉退出时的事件
 */

/**
 * 应用场景：
 * 1.h5 header叉掉
 * 2。pc header
 * 3. 浏览器 关闭事件
 */

// import utils from "../utils";
export default {
  computed: {
    ...mapState({
      isQueue: state => state.isQueue,
      userId: state => state.userId
    })
  },
  methods: {
    unloadFn() {
      // localStorage.setItem("leaveTime", new Date().getTime());
      // // const headerData = utils.getRequestHeader();
      // let endType = 3;
      // // 如果在排队状态
      // if (this.isQueue) {
      //   endType = 4;
      // }
      // const userId = this.userId;
      // let xhr = new XMLHttpRequest();
      // xhr.open("POST", `/api/customer/end`);
      // xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");
      // xhr.setRequestHeader("deviceType", headerData.deviceType);
      // xhr.setRequestHeader("token", headerData.token);
      // xhr.setRequestHeader("productId", headerData.productId);
      // xhr.setRequestHeader("timestamp", headerData.timestamp);
      // xhr.setRequestHeader("ip", headerData.ip);
      // xhr.setRequestHeader("appId", headerData.appId);
      //参数加密
      // const data = {
      //   encryptParam: utils.RSAEncrypt(JSON.stringify({ userId, endType }))
      // };
      // xhr.send(JSON.stringify(data));
      // xhr.onload = function() {
      //   //成功
      // };
    }
  },
  mounted() {
    window.addEventListener("unload", () => this.unloadFn());
  }
};
